<template>
  <v-container fluid pt-2>
    <v-layout style="position: absolute" pt-2>
      <p class="grey--text">
        <span class="welcomeText">
          {{ $t('homePage.welcome') }}
        </span>
      </p>
    </v-layout>

    <!-- LISTE DES CODES PROMOS PUBLIC DISPONIBLES -->
    <v-layout
      column
      align-center
      justify-center
      pt-5
      v-if="hasNotUsedPromoCode"
    >
      <p class="indicationText">
        {{ $t('homePage.createWithCode') }}
      </p>
    </v-layout>

    <v-layout
      column
      wrap
      style="padding-left: 4%; padding-right: 4%; align-items: center"
    >
      <home-page-card
        class="home-card"
        v-for="(pc, index) in promoCodes"
        v-if="validPromoCode(pc) && pc.value !== 'WELCOME'"
        @click.native="openPromoCodeDialog(pc.value)"
        :key="index"
        :picture="pc.logo ? pc.logo : ''"
        :title="pc.name[locale]"
        :details="pc.description[locale]"
        :link="pc.link"
      ></home-page-card>
    </v-layout>

    <!-- PROMO CODE WELCOME 
    
    <v-layout column wrap
      style="padding-left: 4%;padding-right: 4%; align-items: center;">

      <home-page-card class="home-card"
        v-if="Object.keys(userPaths).length===0"
        @click.native="newPath(welcomePromoCode.value)"
        :picture="welcomePromoCode.logo ? welcomePromoCode.logo : ''"
        :title="welcomePromoCode.name[locale]"
        :details="welcomePromoCode.description[locale]"
        ></home-page-card>

    </v-layout>
    -->

    <!-- CARDS PARCOURS EXISTANTS -->

    <v-layout
      column
      align-center
      justify-center
      pt-5
      v-if="idsNonEmptyUserPaths.length > 0"
    >
      <p class="indicationText">
        {{ $t('homePage.consult') }}
      </p>
    </v-layout>

    <v-layout
      column
      align-center
      justify-center
      pb-4
      pt-4
      v-if="idsNonEmptyUserPaths.length < 1"
    >
      <v-icon x-large color="grey lighten-2"> mdi-emoticon-sad </v-icon>
      <p class="indicationText">
        {{ $t('homePage.noPath') }}
      </p>
    </v-layout>
    <v-layout
      column
      wrap
      style="padding-left: 4%; padding-right: 4%; align-items: center"
    >
      <home-page-card
        class="home-card"
        v-for="(path, index) in userPaths"
        :key="index"
        :picture="path.pictures ? path.pictures[0].url : ''"
        :title="(path.name && path.name[locale]) || null"
        :details="(path.description && path.description[locale]) || null"
        :tags="pathTags(path)"
        @click.native="selectedPath(index)"
      >
      </home-page-card>
    </v-layout>


    <!-- CARD POUR GENERER UN PARCOURS GRACE A L'IA -->
    <v-layout
      column
      wrap
      style="padding-left: 4%; padding-right: 4%; align-items: center"
    >
      <!--generation-card></generation-card-->
    </v-layout>

    <!-- CARD POUR AJOUTER UN PARCOURS -->

    <v-layout
      column
      wrap
      style="padding-left: 4%; padding-right: 4%; align-items: center"
    >
      <home-page-card
        class="home-card"
        @click.native="newPath()"
        :isCreation="true"
      >
      </home-page-card>
    </v-layout>

    <v-flex class="contributionClass">
      <upcoming-feature
        :feature="$t(`upcomingFeature.enrichExplorama`)"
        :featureType="'link'"
        :featureBtnText="$t('upcomingFeature.enrichExploramaText')"
        :isTracked="'enrichExplorama'"
      >
      </upcoming-feature>
    </v-flex>

    <home-infos-dialog
      v-if="
        !hasSeenInfoDialog && showDialog && idsNonEmptyUserPaths.length === 0
      "
    >
    </home-infos-dialog>

    <premium-dialog
      v-if="!checkCodeDone && isPremiumDialogOpen"
      :type="typeTextDialog"
      :isTextDialogOpen="isPremiumDialogOpen"
      :title="textDialogInformations[typeTextDialog].title"
      :explanation="textDialogInformations[typeTextDialog].explanation"
      :details="textDialogInformations[typeTextDialog].details"
      :cancelButtonText="textDialogInformations[typeTextDialog].cancel"
      :confirmButtonText="textDialogInformations[typeTextDialog].confirm"
      @confirm="closePremium()"
      @cancel="closePremium()"
    >
    </premium-dialog>

    <!--new-path-dialog
    :isNewPathDialogOpen="isNewPathDialogOpen"
    :accountPathLimit="accountRemainingPath < 0 ? 0 : accountRemainingPath"
    :newPathError="promoCodeError"
    @confirm="handleNewPathConfirm"
    @cancel="closeNewPathDialog"
    >
    </new-path-dialog-->
    <promo-code-dialog
      :isPromoCodeOpen="isPromoCodeDialogOpen"
      :promoCodeValue="promoCodeValue"
      :userPaths="userPaths"
      :promoCodeError="promoCodeError"
      @confirm="applyPromoCode"
      @cancel="closePromoCodeDialog"
    >
    </promo-code-dialog>
  </v-container>
</template>

<script>
import UpcomingFeature from '../components/UpcomingFeature';
import PremiumDialog from '../components/PremiumDialog';
import HomeInfosDialog from '../components/HomeInfosDialog.vue';
import HomePageCard from '../components/HomePageCard.vue';
import PromoCodeDialog from '../components/PromoCodeDialog.vue';
import GenerationCard from '../components/GenerationCard.vue';
//import NewPathDialog from '../components/NewPathDialog.vue';

export default {
  name: 'HomePage',
  components: {
    UpcomingFeature,
    PremiumDialog,
    HomeInfosDialog,
    HomePageCard,
    PromoCodeDialog,
    GenerationCard,
    //NewPathDialog
  },
  data() {
    return {
      tramesInformations: null,
      isPremiumDialogOpen: false,
      //isNewPathDialogOpen: false,
      isPromoCodeDialogOpen: false,
      promoCodeValue: null,
      showDialog: false,
      typeTextDialog: null,
      viergeTrameImage:
        'https://s3.eu-west-3.amazonaws.com/explorama-dev/contentPictures/55f818da-f806-4423-b79a-72af5e89d54c-landscape-2.jpg',
      //daysLeft:0,
      promoCodeError: '',
      counter: 0,
      articlesSuggest: [
        '605b1929c44f5d025f447666', // les grandes étapes
        '630f89f2037bc877147b4d06', // jeux parcours mission: def
        '63c7d2d0ae2ac446a09d40cb', // exemples de parcours explorama
      ],
      articlesTitles: [
        {
          fr: 'Grandes étapes pour concevoir un parcours',
          en: 'Key steps to design a pathway',
        },
        {
          fr: 'Parcours, missions, jeux : définitions',
          en: 'Path, missions, games: definitions',
        },
        {
          fr: 'Exemples de parcours Explorama',
          en: 'Examples of Explorama paths',
        },
      ],
      inputPromoCode: { promoCodeId: '' },
    };
  },
  async beforeMount() {
    try {
      const res = await this.$kuzzle.document.search(
        'public',
        'pathstemplates',
        {}
      );
      this.tramesInformations = res.hits;
    } catch (e) {
      this.errorMessage = e.message;
      console.error(e.message);
    }
    // try {
    //   if (this.checkCodeDone || !this.hasNotUsedPromoCode) {return;}
    //   let {isJustExpired,isValid, daysLeft} = this.checkPromoCode();
    //   console.log('checkpromocode return',isJustExpired,isValid, daysLeft);
    //   if (isJustExpired) {
    //     this.typeTextDialog = 'promoCodeExpired';
    //     this.isPremiumDialogOpen = true;
    //   }
    //   if (isValid) {
    //     this.daysLeft = daysLeft;
    //     this.typeTextDialog = 'promoCodeContinue';
    //     this.isPremiumDialogOpen = true;
    //   }
    // }
    // catch (e) {
    //   this.errorMessage = e.message;
    //   console.error(e.message);
    // }
  },
  mounted() {
    setTimeout(this.setDialogTrue, 3000);
    this.counter = 0;
    window.Beacon('suggest', this.articlesSuggest);
    this.switchHelpScoutText();
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },
    userPaths() {
      return this.$store.state.paths.paths;
    },
    currentAccount() {
      return this.$store.getters['accounts/currentAccount'];
    },
    currentAccountId() {
      return this.$store.getters['accounts/currentAccountId'];
    },
    promoCodes() {
      return this.$store.getters['paths/getPromoCodes'];
    },
    //pathLimit() {
    //  return this.currentAccount.pathLimit || 0;
    //},
    //accountRemainingPath() {
    //  return this.pathLimit - Object.keys(this.userPaths).length + this.currentUserPromoCodes.length;
    //},
    //welcomePromoCode() {
    //  return this.promoCodes.WELCOME;
    //},
    checkCodeDone() {
      return this.$store.state.app.checkCodeDone;
    },
    hasSeenInfoDialog() {
      return localStorage.getItem('hasSeenInfoDialog');
    },
    currentUserPromoCodes() {
      return Object.values(this.userPaths)
        .filter((p) => p.promoCode && p.promoCode.value)
        .map((p) => p.promoCode.value)
        .filter((v) => v !== '');
    },

    hasNotUsedPromoCode() {
      return (
        this.dif(
          Object.keys(this.promoCodes).filter((pc) => pc !== 'WELCOME'),
          this.currentUserPromoCodes
        ).length > 0
      );
    },
    hasValidPromoCode() {
      return Object.values(this.promoCodes).find((pc) =>
        this.validPromoCode(pc)
      );
    },
    //hasValidPromoCodeNotWelcome() {
    //  return this.hasValidPromoCode && this.hasValidPromoCode.value !== 'WELCOME'
    //},
    idsNonEmptyUserPaths() {
      let ids = Object.keys(this.userPaths);
      if (ids) {
        ids = ids.filter(
          (id) =>
            this.userPaths[id].name.fr !== '' ||
            this.userPaths[id].name.en !== ''
        );
        return ids;
      }
      return [];
    },
    /*textDialogInformations() {
      return {
        pathLimit: {
          title: this.$t('premiumDialog.title.pathLimit'),
          explanation: this.$t('settingsBar.textDialogInformations.pathLimit.explanation'),
          details: this.$t('settingsBar.textDialogInformations.pathLimit.details'),
          confirm: this.$t('settingsBar.textDialogInformations.pathLimit.confirm'),
          confirmButtonColor: 'primary'  
        },
        promoCodeExpired: {
          title: this.$t('promoCodeDialog.expired.title'),
          explanation: this.$t('promoCodeDialog.expired.explanation'),
          details: this.$t('promoCodeDialog.expired.details'),
          confirm: this.$t('promoCodeDialog.expired.confirm'),
          cancel: this.$t('promoCodeDialog.expired.cancel')
        },
        promoCodeContinue: {
          title: this.$tc('promoCodeDialog.continue.title',this.daysLeft),
          explanation: this.$t('promoCodeDialog.continue.explanation'),
          //details: this.$t('promoCodeDialog.continue.details'),
          confirm: this.$t('promoCodeDialog.continue.confirm'),
          cancel: this.$t('promoCodeDialog.continue.cancel'),
          confirmButtonColor: 'primary'  
        }
      };
    }*/
  },
  methods: {
    dif(arr1, arr2) {
      return [...new Set(arr1.filter((el) => !arr2.includes(el)))];
    },
    pathTags(path) {
      let tags = [];

      if (path.isPublished) {
        tags.push(this.$t('homePage.cardTags.published'));
      }
      if (path.isApproved) {
        tags.push(this.$t('homePage.cardTags.approved'));
      }
      if (path.dateEnd < new Date().getTime()) {
        tags.push(this.$t('homePage.cardTags.expired'));
      }
      if (path.promoCode) {
        if (path.promoCode.type === 'event') {
          tags.push(this.$t('homePage.cardTags.event'));
        } else if (path.promoCode.value.toLowerCase() === 'welcome') {
          //tags.push(this.$t('homePage.cardTags.welcome'));
          tags.push(this.$t('homePage.cardTags.free'));
        } else if (path.promoCode.type === 'trial') {
          tags.push(this.$t('homePage.cardTags.trial'));
        }
      }

      return tags;
    },
    isPromoCodeUsed(pc) {
      return this.currentUserPromoCodes.find((val) => val === pc);
    },
    datediff(first, second) {
      // source: https://stackoverflow.com/questions/542938/how-do-i-get-the-number-of-days-between-two-dates-in-javascript
      // Take the difference between the dates and divide by milliseconds per day.
      // Round to nearest whole number to deal with DST.
      return Math.round((second - first) / (1000 * 60 * 60 * 24));
    },
    isPromoCodeExpired(pc) {
      return this.datediff(new Date().getTime(), pc.endDate) <= 0;
    },
    validPromoCode(pc) {
      return !this.isPromoCodeUsed(pc.value) && !this.isPromoCodeExpired(pc);
    },
    applyPromoCode(pathId, pc) {
      console.log('apply PC confirm');
      if (pathId === 'new') {
        this.handleNewPathConfirm('confirm', pc);
      } else {
        this.addPromoCodeToPath(pathId, pc);
      }
    },
    handleNewPathConfirm(option, pc) {
      console.log('option', option, pc);
      if (option === 'use') {
        this.newPath();
      } else if (option === 'confirm' && pc) {
        this.newPath(pc);
      } else {
        this.isPremiumDialogOpen = true;
        //this.typeTextDialog = 'pathLimit';
      }
    },
    async addPromoCodeToPath(pathId, pc) {
      console.log('add PC to path', pathId, pc);
      const payload = { promoCode: { value: pc } };
      try {
        await this.$store.dispatch('paths/UPDATE_PATH', {
          pathPayload: payload,
          index: this.$store.getters['auth/currentUserIndex'],
          pathId: pathId,
          kuzzle: this.$kuzzle,
        });
        this.closePromoCodeDialog();
      } catch (e) {
        console.log('update error', e);
        this.handleErrorMessage(e);
      }
    },
    //openNewPathDialog() {
    //  this.isNewPathDialogOpen = true;
    //},
    //closeNewPathDialog() {
    //  this.isNewPathDialogOpen = false;
    //},
    openPromoCodeDialog(val) {
      console.log('pc val', val);
      this.isPromoCodeDialogOpen = true;
      this.promoCodeValue = val;
    },
    closePromoCodeDialog() {
      this.isPromoCodeDialogOpen = false;
      this.promoCodeValue = null;
    },
    switchHelpScoutText() {
      if (this.$route.name !== 'homePage') {
        return;
      }
      switch (this.counter) {
        case 0:
          window.Beacon('config', {
            display: {
              style: 'iconAndText',
              text: this.articlesTitles[0][this.locale],
              iconImage: 'buoy',
            },
          });
          this.counter++;
          setTimeout(this.switchHelpScoutText, 5000);
          break;
        case 1:
          window.Beacon('config', {
            display: {
              style: 'iconAndText',
              text: this.articlesTitles[1][this.locale],
              iconImage: 'buoy',
            },
          });
          this.counter++;
          setTimeout(this.switchHelpScoutText, 5000);
          break;
        case 2:
          window.Beacon('config', {
            display: {
              style: 'iconAndText',
              text: this.articlesTitles[2][this.locale],
              iconImage: 'buoy',
            },
          });
          this.counter = 0;
          setTimeout(this.switchHelpScoutText, 5000);
          break;
      }
    },
    setDialogTrue() {
      this.showDialog = true;
    },
    async newPath(promoCode) {
      console.log('newPath:', promoCode);
      // if(Object.keys(this.userPaths).length>=this.pathLimit && !promoCode) {
      //if (this.accountRemainingPath < 1 && !promoCode) {
      //  this.openTextDialog('pathLimit');
      //  return;
      //}
      let pathEmptyId = this.$store.getters['paths/getPathEmptyId']({
        fr: '',
        en: '',
      });

      localStorage.setItem('pathLang', 'fr');
      if (pathEmptyId) {
        this.$router.push(`/pathManagement/${pathEmptyId}`);
      } else {
        try {
          let path = {
            name: { fr: '', en: '' },
            description: { fr: '', en: '' },
            introduction: { fr: '', en: '' },
            isPublished: false,
            missions: [],
            rewards: [],
            conclusion: { fr: '', en: '' },
            langsEdited: [this.locale],
            langsPublished: [],
            isMapAvailable: true,
          };

          if (promoCode) {
            path.promoCode = { value: promoCode.toUpperCase() };
          }
          //else {path.dateEnd = this.currentAccount.subscriptionEnd;}

          let newPath = await this.$store.dispatch('paths/CREATE_PATH', {
            newPathPayload: path,
            index: 'clients',
            kuzzle: this.$kuzzle,
          });
          const pathId = newPath._id;
          this.$router.push(`/pathManagement/${pathId}`);
          //this.isNewPathDialogOpen=false;
        } catch (error) {
          console.error(error.message, error.message.match(/.*not found.*/));
          this.handleErrorMessage(error);

          // this.$toast.show(error, this.$t('pathForm.title'));
        }
      }
    },
    handleErrorMessage(error) {
      if (error.message.match(/.*not found.*/)) {
        this.promoCodeError = this.$t('homePage.errors.promoCodeWrong');
      } else if (error.message.match(/.*promoCode expired.*/)) {
        this.promoCodeError = this.$t('homePage.errors.promoCodeExpired');
      } else if (error.message.match(/.*promoCode already used.*/)) {
        this.promoCodeError = this.$t('homePage.errors.promoCodeUsed');
      } else if (error.message.match(/.*promoCode maximum.*/)) {
        this.promoCodeError = this.$t('homePage.errors.maximumReached');
      } else {
        this.promoCodeError = this.$t('homePage.errors.promoCodeEerror');
      }
    },
    openTextDialog(type) {
      console.log('type:', type);
      this.isPremiumDialogOpen = true;
      this.typeTextDialog = type;
    },
    async closePremium() {
      this.$store.commit('app/UNSET_LOADING');
      this.typeTextDialog = null;
      this.isPremiumDialogOpen = false;
      // this.$store.commit('app/UPDATE_CHECKCODEDONE', true);
    },
    async selectedPath(pathId) {
      console.log('SELECTED PATH');
      localStorage.setItem('pathLang', 'fr');
      this.$router.push(`/pathManagement/${pathId}`);
    },
    /*
    async duplicateTrame(trameId) {
      //if(Object.keys(this.userPaths).length>=this.pathLimit) {
      //  this.openTextDialog('pathLimit');
      //  return;
      //}
      try {
        const res = await this.$kuzzle.query({
          controller: 'duplicate',
          action: 'path',
          body: {
            indexA: 'public',
            collectionA: 'pathstemplates',
            indexB: this.$store.getters['auth/currentUserIndex'],
            pathId: trameId,
          },
        });
        let newPath = res.result;
        console.log(newPath);
        if (newPath) {
          this.$router.push(`/pathManagement/${newPath._id}`);
        }
      } catch (e) {
        this.errorMessage = e.message;
        console.error(e.message);
      }
    },
    */
  },
};
</script>

<style lang="sass">

.home-card
  margin: 30px;

.indicationText
  font-size: x-large;
  text-align: center;
  text-justify: center;
  line-height: 120%

.pathCard
  margin: 15px
  height: 210px
  width: 240px

.trameCard
  border-radius: 14px !important
  margin: 15px
  height: 160px
  width: 180px

.viergeCard
  border-radius: 14px !important
  height: 190px
  width: 210px

.trameImage
  height: 100%
  width: 100%

.trameText
  color: white
  font-size: medium;
  text-align: center;
  text-justify: center;
  line-height: 120%;
  margin-bottom: 5px;

.pointerClass
  cursor: pointer

.shadowEffect
  background-image: linear-gradient(to bottom, transparent, 90%, black);
  height: 100%
  width: 100%

.shadowBox
  background-image: linear-gradient(to bottom, #009999, 60%, #003D3D);
  height: 100%
  width: 100%

.pointerClass:hover
  opacity: 0.9

.welcomeText
  font-size: large;
  font-style: italic;
  text-align: justify;
  text-justify: inter-word;
  line-height: 150%

.contributionClass
  position: absolute;
  bottom: 0%

.v-window__container
  height: 200px;
</style>
